import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analyticsAPI } from '@/services/api';
import { initGA, gaPageview } from '@/lib/ga';

// Records a first-party pageview on every route change (admin excluded) and,
// after statistics consent, mirrors the pageview to Google Analytics 4.
// analyticsAPI.track() self-gates on statistics consent; initGA() only loads GA after consent.
export const AnalyticsTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/admin')) return;
    analyticsAPI.track('pageview', { path: location.pathname });
    initGA();
    gaPageview(location.pathname);
    // If the user grants consent later, boot GA and capture the current pageview once.
    const onConsent = () => {
      if (!location.pathname.startsWith('/admin')) {
        analyticsAPI.track('pageview', { path: location.pathname });
        initGA();
        gaPageview(location.pathname);
      }
    };
    window.addEventListener('nb-consent-change', onConsent);
    return () => window.removeEventListener('nb-consent-change', onConsent);
  }, [location.pathname]);

  return null;
};
